// @ts-ignore
import coreStore from '@/stores/core';

export const isShortCutNewUI = () => {
  const newUIGroup = [
    'new_ui',
    'new_ui_no_sc',
    'popup',
    'popup_no_sc',
    'new_ui_10_sc',
    'new_ui_no_sc_10_sc',
    'popup_10_sc',
    'popup_no_sc_10_sc',
  ];
  return newUIGroup.includes((coreStore.safeGetStore('userStore').newABTestingConfigs as any)?.shortcut_uiux);
};

export const isNoShortCutWhenTyping = () => {
  const noSCGroup = ['new_ui_no_sc', 'popup_no_sc', 'new_ui_no_sc_10_sc', 'popup_no_sc_10_sc'];
  return noSCGroup.includes((coreStore.safeGetStore('userStore').newABTestingConfigs as any)?.shortcut_uiux);
};

export const isShortCutPopupDisplay = () => {
  const noSCGroup = ['popup', 'popup_no_sc', 'popup_10_sc', 'popup_no_sc_10_sc'];
  const shortcut_uiux = (coreStore.safeGetStore('userStore').newABTestingConfigs as any)?.shortcut_uiux;

  if (
    (shortcut_uiux === 'popup' || shortcut_uiux === 'popup_10_sc')
    && coreStore.safeGetStore('inputStore').isInputFocus
  ) {
    return false;
  }

  return noSCGroup.includes(shortcut_uiux);
};

export const getShortCutUIUXExperiment = () => {
  return (coreStore.safeGetStore('userStore').newABTestingConfigs as any)?.shortcut_uiux;
};

export const isLiveAgentScUIOptimisation = () => {
  return (coreStore.safeGetStore('userStore').newABTestingConfigs as any)?.live_agent_sc_ui === 'test';
};
